import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { useCookies } from 'react-cookie';
import { setDefaultSessionExpiredHandler } from '../api/ApiFetch';
import { useSnackbar } from '../context/SnackbarContext';

export const useSessionExpiredHandler = () => {
  const [, , removeCookie] = useCookies(['user_session_token']);
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    setDefaultSessionExpiredHandler(() => {
      removeCookie('user_session_token', { path: '/' });
      Sentry.setUser(null);
      showSnackbar('Session token invalid or expired - Signing out', 'error');
      setTimeout(() => window.location.reload(), 500);
    });
  }, [removeCookie, showSnackbar]);
};
